export function toSmallestUnit(amount: number): number {
  return amount ? amount * 100 : 0;
}

export function fromSmallestUnit(amount: number): number {
  return amount ? amount / 100 : 0;
}
